import { BaseService } from '@common/http-layer/service/base.service'

/**
 * Community User service - handles user profile API calls
 * Base URL: COMMUNITIES_SERVER_URL
 * Base Path: /communities/{locationId}/users
 */
export class GokollabCommunityUserService extends BaseService {
  constructor() {
    super({
      baseURL: 'GOKOLLAB_SERVER_URL',
      basePath: '', // Static part of the path
    })
  }

  /**
   * Get whitelabel (gokollab) contactId for the current portal user.
   * Used when isGokollab: maps portal contactId to location-specific contactId.
   */
  async getGokollabContactId(locationId: string, contactId: string, forceCreate: boolean = true): Promise<{ contactId: string }> {
    const { data } = await this.get<{ contactId: string }>(`/${locationId}/users/gokollab-contact-id/${contactId}`, {
      locationId,
      params: { forceCreate: forceCreate.toString() },
    })
    return { contactId: data?.contactId ?? contactId }
  }
}
